import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container py-4" }
const _hoisted_2 = {
  key: 0,
  class: "mb-4 p-2 rounded-pill bg-secondary bg-opacity-10 text-center fs-4 fw-bold text-secondary"
}
const _hoisted_3 = { class: "row g-2 statistics-item" }
const _hoisted_4 = { class: "col border-end border-right-dashed" }
const _hoisted_5 = { class: "statistics-item h-100 span-vertical-between" }
const _hoisted_6 = { class: "text-end" }
const _hoisted_7 = { class: "display-3 text-primary" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "statistics-item h-100 span-vertical-between" }
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = { class: "amount text-primary" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "statistics-item span-between" }
const _hoisted_14 = { class: "amount text-primary" }
const _hoisted_15 = { class: "statistics-item span-between" }
const _hoisted_16 = { class: "amount text-primary" }
const _hoisted_17 = { class: "statistics-item span-between" }
const _hoisted_18 = { class: "amount text-primary" }
const _hoisted_19 = { class: "statistics-item span-between" }
const _hoisted_20 = { class: "amount text-primary" }

import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { parseISO, format } from "date-fns";
import { isInvalid } from "@/utility/date";
import { StatisticsShowType } from "@/interface/order";
import {
  OperationMonthReport,
  OperationDayReport,
} from "@/api/driverApi/records";
import { OperationReportModel } from "@/interface/report";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderStatisticsView',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const router = useRouter();

const type = route.params.type as StatisticsShowType;
const date = parseISO(route.params.date as string);
const isinvalid = isInvalid(date);
const reportData = ref<OperationReportModel | null>(null);

if (!isinvalid) router.go(-1);

const fetchData = async () => {
  const xhr =
    type === StatisticsShowType.Month
      ? OperationMonthReport(date)
      : OperationDayReport(date);
  const { data } = await xhr;
  reportData.value = data;
};

const DayStringFormat = (date: Date) => {
  return format(date, "yyyy 年 MM 月 dd 日");
};

;(
  ([__temp,__restore] = _withAsyncContext(() => fetchData())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(type) == _unref(StatisticsShowType).Day)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(DayStringFormat(_unref(date))), 1))
      : _createCommentVNode("", true),
    _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "fw-bold text-secondary" }, "營運統計", -1)),
    _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "my-2 hr-dashed" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-secondary text-spacing-3" }, "預約單", -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(reportData.value?.BookingFinishTotal ?? "-"), 1),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-secondary d-inline-block rounded-pill bg-primary-light ms-1" }, "趟", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-secondary text-spacing-3" }, "即時叫車", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(reportData.value?.InstantFinishTotal ?? "-"), 1),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-secondary d-inline-block rounded-pill bg-primary-light ms-1" }, "趟", -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-secondary text-spacing-3" }, "總趟數", -1)),
        _createElementVNode("span", _hoisted_14, _toDisplayString(reportData.value?.TripsTotal), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-secondary text-spacing-3" }, [
          _createTextVNode("優惠券"),
          _createElementVNode("br"),
          _createTextVNode("使用次數")
        ], -1)),
        _createElementVNode("span", _hoisted_16, _toDisplayString(reportData.value?.BonusTripsTotal ?? "-"), 1)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-secondary text-spacing-3" }, "跳表金額", -1)),
        _createElementVNode("span", _hoisted_18, _toDisplayString(reportData.value?.FareCostTotal ?? "-"), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-secondary text-spacing-3" }, [
          _createTextVNode("優惠券"),
          _createElementVNode("br"),
          _createTextVNode("金額")
        ], -1)),
        _createElementVNode("span", _hoisted_20, _toDisplayString(reportData.value?.BonusPriceTotal ?? "-"), 1)
      ])
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("hr", { class: "my-2 hr-dashed" }, null, -1))
  ]))
}
}

})